<template>
  <Grid
    class="recent-submissions-grid"
    :data-items="submissions"
    :columns="columns"
    :loader="loading"
    data-cy="recent-submissions-grid"
  >
    <template v-slot:JobIdCell="{ props: { dataItem, field } }">
      <td class="k-table-td">
        <span
          class="details-action"
          @click="onDetailsClicked(dataItem)"
          data-cy="details-action"
          >{{ dataItem[field] }}</span
        >
      </td>
    </template>
  </Grid>
</template>

<script setup lang="ts">
import { Grid } from "@progress/kendo-vue-grid";
import { ref } from "vue";
import type { GridColumnPropsExtended } from "@/Domain/GridColumnPropsExtended";
import type { SubmissionsTable } from "@/Domain/SubmissionsTable";

defineProps<{
  submissions: SubmissionsTable[];
  loading?: boolean;
}>();

const emits = defineEmits<{
  (e: "detailsClicked", transaction: SubmissionsTable): void;
}>();

const columns = ref<GridColumnPropsExtended[]>([
  {
    title: "Job Id",
    field: "JobId",
    cell: "JobIdCell",
  },
  {
    title: "Job Type",
    field: "JobType",
  },
  {
    title: "Status",
    field: "Status",
  },
  {
    title: "Date Submitted",
    field: "DateProcessed",
  },
]);

const onDetailsClicked = (transaction: SubmissionsTable) => {
  emits("detailsClicked", transaction);
};
</script>

<style scoped lang="scss">
.recent-submissions-grid {
  min-height: 100px;
  max-height: 350px;
}

.k-grid {
  td {
    .details-action {
      color: #337ab7;
      cursor: pointer;
    }
  }
}
</style>
